import { RewardsBrand } from '@ps/web-core-enums';
import React from 'react';
import { useSelector } from 'react-redux';

import LogoFoxBet from '@swf/components/StarsRewards/assets/logo-foxbet.svg';
import LogoPokerStarsInverse from '@swf/components/StarsRewards/assets/logo-pokerstars-inverse.svg';
import LogoPokerStars from '@swf/components/StarsRewards/assets/logo-pokerstars.svg';
import styles from '@swf/components/StarsRewards/components/Optin/Optin.scss';
import { select } from '@swf/core/store';

export interface Props {
  inverse?: boolean;
}

const RewardsLogo: React.FC<Props> = (props) => {
  const program = useSelector(select.rewardsLegacy.getRewardsBrand);

  if (program === RewardsBrand.FoxBet)
    return <LogoFoxBet className={props.inverse ? styles.inverseLogo : styles.logo} />;

  return props.inverse ? (
    <LogoPokerStarsInverse className={styles.inverseLogo} />
  ) : (
    <LogoPokerStars className={styles.logo} />
  );
};

export default RewardsLogo;
